import { styled } from "@mui/system";
import { Button } from "@mui/material";

export const NextButton = styled(Button)({
  display: "flex",
  padding: "12px",
  height: "43px",
  border: "none",
  color: "white",
  background: "#FC4C4C",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "8px",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "19px",
  textTransform: "none",
  ":hover": {
    background: "darkgrey",
  },
});

export const BackButton = styled(Button)({
  display: "flex",
  height: "43px",
  padding: "12px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "8px",
  border: "1px solid var(--neutral-200, #D1D4D6)",
  fontWeight: "600",
  textTransform: "none",
  fontSize: "16px",
});
